const EventEmitter = require('eventemitter3');
import getUnitState from '../../../isomorphic-helpers/getUnitState';
const BattleCalc = require('../../BattleCalc');
const Poppet = require('../../../models/game_pieces/ai_units/summoned_units/Poppet');
const SummonedCondition = require('../../conditions/SummonedCondition');
const { logError } = require('../../logger');
const DeathEvent = require('../../events/DeathEvent');
const { v4: uuidv4 } = require('uuid');

export default function FauxSelf(battleState) {
  this.handle = 'faux_self';
  this.magic = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor) {
    return twoAdjacentTilesAreUnnocupied();

    function twoAdjacentTilesAreUnnocupied() {
      let numUnoccupied = 0;
      const allAdjacentTiles = battleState.getAdjacentTiles(actor);

      for (let i = 0; i < allAdjacentTiles.length; ++i) {
        if (allAdjacentTiles[i] && !allAdjacentTiles[i].occupied) {
          ++numUnoccupied;
        }
      }

      return numUnoccupied >= 2;
    }
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay) {
      return { success: false };
    }

    try {
      const ability = BattleCalc.getEquippedAbility(actor, this.handle);

      // calculate target tiles
      const targetTiles = [];
      const adjacentTiles = battleState.getAdjacentTiles(actor);
      const candidateTiles = [];
      for (let i = 0; i < adjacentTiles.length; ++i) {
        if (!adjacentTiles[i].occupied) {
          candidateTiles.push(adjacentTiles[i]);
        }
      }

      const chance1 = Math.floor(Math.random() * candidateTiles.length);
      targetTiles.push(candidateTiles[chance1]);

      let chance2;
      do {
        chance2 = Math.floor(Math.random() * candidateTiles.length);
      } while (chance2 === chance1);
      targetTiles.push(candidateTiles[chance2]);

      // kill poppets on the board if above max
      const myPoppets = Object.values(battleState?.allUnits).filter(
        (unit) => unit.handle === 'poppet' && unit.ownerId === actor.uid
      );
      const max_num_poppets = BattleCalc.getMaxNumSummons({
        ability_handle: ability.handle,
        caster_build: actor,
      });
      if (myPoppets.length + 2 >= max_num_poppets) {
        const num_to_kill = myPoppets.length + 2 - max_num_poppets;
        for (let i = 0; i < num_to_kill; ++i) {
          const random_poppet_index = Math.floor(Math.random() * myPoppets.length);
          const [poppet_to_kill] = myPoppets.splice(random_poppet_index, 1);
          new DeathEvent(battleState).execute(poppet_to_kill);
        }
      }

      // make the poppets
      const poppet_states = [];

      let fu = Poppet(ability.potency, actor);
      fu.ability_trees = fu.getAbilityTrees();
      fu.attributes = { base: fu.getBaseAttributes() };
      let fu_unit_state = getUnitState({ ai_unit: fu });
      fu_unit_state.hp = fu_unit_state.max_hp;
      // the first one takes the actor's place
      fu_unit_state.x = actor.x;
      fu_unit_state.y = actor.y;
      poppet_states.push(fu_unit_state);

      fu = Poppet(ability.potency, actor);
      fu.ability_trees = fu.getAbilityTrees();
      fu.attributes = { base: fu.getBaseAttributes() };
      fu_unit_state = getUnitState({ ai_unit: fu });
      fu_unit_state.hp = fu_unit_state.max_hp;
      fu_unit_state.x = targetTiles[0].x;
      fu_unit_state.y = targetTiles[0].y;
      poppet_states.push(fu_unit_state);

      // the actor moves to one of the spawn tiles
      actor.x = targetTiles[1].x;
      actor.y = targetTiles[1].y;
      targetTiles[1].occupied = true;

      for (const poppet_state of poppet_states) {
        poppet_state.uid = uuidv4();
        poppet_state.ownerId = actor.uid;
        battleState.registerNewUnit(poppet_state);
        battleState.onUnitCondition(
          new SummonedCondition(actor, poppet_state, battleState, ability.duration)
        );
      }

      this.eventEmitter.emit('result', {
        success: true,
        abilityHandle: this.handle,
        actorId: actor.uid,
        newActorCoords: { x: actor.x, y: actor.y },
        poppets: poppet_states,
      });
    } catch (err) {
      logError(err, {
        module: 'FauxSelf',
        func: 'execute',
        actor,
        victim,
      });

      return { success: false };
    }
  };
}
